interface IOrderBy<Data> {
  data: Data[];
  field: keyof Data;
  asc: boolean;
}
type ISortDataType = number | string | boolean;

export const orderBy = <Data>({ data, field, asc }: IOrderBy<Data>): Data[] => {
  data.sort((a, b) => {
    let aField: unknown = a[field];
    let bField: unknown = b[field];
    if (!isNaN(Number(aField)) && !isNaN(Number(bField))) {
      aField = Number(aField);
      bField = Number(bField);
    }
    if (
      (typeof aField === "number" && typeof bField === "number") ||
      (typeof aField === "string" && typeof bField === "string") ||
      (typeof aField === "boolean" && typeof bField === "boolean")
    ) {
      return sortData(aField, bField, asc);
    }
    return 0;
  });
  return data;
};

const sortData = (
  aField: ISortDataType,
  bField: ISortDataType,
  asc: boolean
): 1 | 0 | -1 => {
  if (asc) {
    if (aField < bField) {
      return -1;
    }
    if (aField > bField) {
      return 1;
    }
    return 0;
  } else {
    if (aField > bField) {
      return -1;
    }
    if (aField < bField) {
      return 1;
    }
    return 0;
  }
};
